import { render, staticRenderFns } from "./video-calibrations.vue?vue&type=template&id=39491620&scoped=true"
import script from "./video-calibrations.vue?vue&type=script&lang=js"
export * from "./video-calibrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39491620",
  null
  
)

export default component.exports